import {createReducer} from '@reduxjs/toolkit';
import {AuthState} from './types';
import {AuthActions} from 'store/auth/auth.action';
import {checkinActions} from 'store/checkin/checkin.action';

const initialState: AuthState = {
    isAuth:false,
    isError:false,
    isLoading:false,
    initialized:false,
    hasConfirmedBooking:false,
};

export const authReducer = createReducer(initialState, (builder) => {
    builder.addCase(AuthActions.logoutAction.fulfilled,(state, action) => {
        return{
            isAuth:false,
            user:undefined,
            bookingId:undefined,
            initialized:true,
            isError:false,
            isLoading:false,
            hasConfirmedBooking:false
        }
    })

    builder.addCase(AuthActions.refreshAuthAction, (state, action) => {
        return state
    });

    builder.addCase(AuthActions.loginAction.pending, (state, action) => {
        return{
            ...state,
            isLoading:true,
            isError:false
        }
    });

    builder.addCase(AuthActions.loginAction.fulfilled, (state, action) => {
        return {
            ...state,
            isAuth: action.payload.isAuth,
            isError:false,
            isLoading:false,
            initialized:true,
            hasConfirmedBooking: action.payload.hasConfirmedBooking
        }
    });

    builder.addCase(AuthActions.loginAction.rejected, (state, action) => {
        return {
            ...state,
            user:undefined,
            isAuth: false,
            isError:false,
            isLoading:false,
            initialized:true
        }
    });

    builder.addCase(AuthActions.authenticateWithToken.fulfilled, (state, action) => {
        return {
            ...state,
            isAuth: action.payload.isAuth,
            isError:false,
            isLoading:false,
            initialized:true,
            hasConfirmedBooking: action.payload.hasConfirmedBooking
        }
    });

    builder.addCase(AuthActions.authenticateWithToken.pending, (state, action) => {
        return {
            ...state,
            isError:false,
            isLoading:true,
        }
    });

    builder.addCase(AuthActions.authenticateWithToken.rejected, (state, action) => {
        return {
            ...state,
            isError:true,
            isLoading:false,
        }
    });

    builder.addCase(checkinActions.confirmCheckIn.fulfilled, (state, action) => {
        return {
            ...state,
            hasConfirmedBooking: true
        }
    });

    builder.addDefaultCase((state, action) => {
        return state;
    });
});
